import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, NgZone, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import { SharedModalService } from "@app/shared-modal/service/shared-modal.service";
import { IntegrationsService } from '@app/features/company-settings/integrations/services/integrations.service';
import { AuthService, HybridFactory } from "@app/core";
import { DomSanitizer } from '@angular/platform-browser';
var CallLogModalComponent = /** @class */ (function () {
    function CallLogModalComponent(fb, opportunityService, integrationsService, sharedModalService, zone, authService, confirmationBoxHelper, ajsScope, sanitizer) {
        var _this = this;
        this.fb = fb;
        this.opportunityService = opportunityService;
        this.integrationsService = integrationsService;
        this.sharedModalService = sharedModalService;
        this.zone = zone;
        this.authService = authService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this.sanitizer = sanitizer;
        this.callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
        this.scheduled = true;
        this.subscriptions = {};
        this.callActivityShow = false;
        this.activityIsScheduled = [];
        this.completed = true;
        this.saveDisabled = false;
        this.isContactNotFound = false;
        this.showAddNewTemplate = false;
        this.showTemplateList = false;
        this.customTagsList = [];
        this.customFields = [];
        this.customFieldsDirectResponse = null;
        this.showRecommendation = false;
        this.isCallCustomFieldEnabled = false;
        this.showCallLogModal = false;
        this.showCallCustomFields = false;
        this.showCallNoteTemplateOption = false;
        this.onSave = new EventEmitter();
        this.onClose = new EventEmitter();
        this.users = [];
        this.selectedUsersList = [];
        this.screen = '';
        this.isNotificationPopup = false;
        // Dialpad permissions (readaccess/writeaccess) passed by the notification bar; only used when isNotificationPopup
        this.dialpadAccess = {};
        // Distinct from userInfo.dialpad/callinfo.dialpad (existing "call came via Dialpad
        // integration" signals) - this flag means "this modal instance belongs to the new
        // Dial Pad UI feature" and gates Dial-Pad-specific display/behavior below.
        this.dialPad = false;
        this.onlyArchivedFound = false;
        this.sendValue = new EventEmitter();
        this.onChange = function () {
            var message = _this.callForm.value.note;
            if (_this.showCallNoteTemplateOption) {
                _this.customTagsList.forEach(function (ct) {
                    if (!message.includes(">{" + ct.name + "}</") && !_this.customTagForm.controls[ct.name].value) {
                        _this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                        _this.customTagForm.controls[ct.name].disable();
                    }
                });
            }
        };
        this.isCallCustomFieldEnabled = this.authService.permitted(['UseCallFields.readaccess']) === true;
    }
    CallLogModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.customTagForm = this.fb.group({});
        if (this.showCallCustomFields) {
            this.opportunityService.listCallCustomFields().subscribe(function (res) {
                _this.getCustomFieldCall = res;
                _this.buildCustomeFieldForm(res);
                _this.customFieldsDirectResponse = res['customCallField'];
                // To show the list in this specific order, we mapped like this
                if (res['customCallField']['Reason for call']) {
                    _this.customFields.push({ key: 'Reason for call', value: res['customCallField']['Reason for call'] });
                }
                if (res['customCallField']['Type of call']) {
                    _this.customFields.push({ key: 'Type of call', value: res['customCallField']['Type of call'] });
                }
                if (res['customCallField']['Outcome of call']) {
                    _this.customFields.push({ key: 'Outcome of call', value: res['customCallField']['Outcome of call'] });
                }
                // Dial Pad only - built once here (not from the template) so app-cs-drop-down
                // receives a stable object reference. It only runs its item setup once, in its
                // own ngOnInit, and has no ngOnChanges - a fresh object on every change-detection
                // cycle (e.g. from calling this inline in the template) leaves later items
                // without an itemTemplateType, which throws and silently breaks rendering for
                // the whole list.
                _this.customFields.forEach(function (cf) {
                    cf.ddConfig = _this.buildCustomFieldDdConfig(cf);
                });
                var isValidArray = [];
                if (_this.customFields.length) {
                    _this.customFields.forEach(function (cfObj) {
                        var isValidObj = !!cfObj.value.find(function (cf) { return cf.archived == 0; });
                        if (!isValidObj) {
                            isValidArray.push(false);
                        }
                        else {
                            isValidArray.push(true);
                        }
                    });
                    _this.onlyArchivedFound = !isValidArray.includes(true);
                }
                _this.patchEditedCallCustomFields();
            });
        }
        this.getUserList();
    };
    CallLogModalComponent.prototype.buildCustomeFieldForm = function (field) {
        var csof = {};
        Object.entries(field['customCallField']).forEach(function (item) {
            csof[item[0]] = new FormControl('', Validators.required);
        });
        this.customFieldForm = this.fb.group(csof);
    };
    // Patches customFieldForm from editCallData once customFieldsDirectResponse/customFieldForm
    // are actually populated (both only arrive after listCallCustomFields() resolves in
    // ngOnInit). Called both from the ngOnChanges edit-branch's timeout (handles the common
    // case where the API already responded) and again once listCallCustomFields() resolves
    // (handles a slower API response, where the timeout would otherwise fire before the
    // data existed) - safe to call twice, it just reassigns the same values.
    CallLogModalComponent.prototype.patchEditedCallCustomFields = function () {
        if (!this.editCallData || !this.editCallData.communications || !this.customFieldsDirectResponse || !this.customFieldForm) {
            return;
        }
        var cfs = this.editCallData.communications['customFields'];
        if (!cfs) {
            return;
        }
        var customFieldsDirectResponse = this.customFieldsDirectResponse;
        var editedCfs = {};
        Object.entries(cfs).forEach(function (kvArray) {
            if (kvArray[1] && customFieldsDirectResponse[kvArray[0]]) {
                editedCfs[kvArray[0]] = customFieldsDirectResponse[kvArray[0]].find(function (f) { return f.id == kvArray[1]; });
            }
        });
        this.customFieldForm.patchValue(editedCfs);
        this.refreshCustomFieldDdTogglerText();
    };
    CallLogModalComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.showCallLogModal) {
            if (this.editCallData &&
                this.editCallData.communications &&
                this.editCallData.communications.opportunity) {
                this.screen = 'opportunity_notes';
                this.getUserList();
            }
            if (this.getCustomFieldCall) {
                this.buildCustomeFieldForm(this.getCustomFieldCall);
            }
            if (this.showCallLogModal) {
                this.getUserList();
                if (this.editCallData == null) {
                    var showContent = 'call';
                    if (this.activityList) {
                        /* for (var filter = 0; filter < this.activityList.length; filter++) {
                             // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                 if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                     && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                     this.activityIsScheduled.push(this.activityList[filter])
                             // }
                         }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true;
                            for (var i = 0; i <= this.activityList[1].length; i++) {
                                if (this.activityList[1][i] && this.activityList[1][i].template) {
                                    this.selectedCallNoteTemplate = this.activityList[1][i].template;
                                    this.showRecommendation = true;
                                    break;
                                }
                            }
                            this.completed = true;
                        }
                        else {
                            this.callActivityShow = false;
                            this.completed = false;
                        }
                    }
                    if (this.completedActivityData && (this.completedActivityData.template || this.completedActivityData.templateName)) {
                        this.selectedCallNoteTemplate = this.completedActivityData;
                        this.showRecommendation = true;
                    }
                    this.buildForm();
                    setTimeout(function () {
                        _this.todayActivity();
                    }, 500);
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    // setTimeout(() => {
                    //     this.updateTinyMCEValues();
                    // }, 100);
                }
                else {
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId;
                        this.callActivityShow = false;
                        this.buildForm();
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note": this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        });
                        setTimeout(function () {
                            _this.patchEditedCallCustomFields();
                            // increased 500 ms extra to get customFieldsDirectResponse
                        }, 1500);
                        $(".modal-header").css("background", "#5E6D7F");
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open");
                        $('.callLogModal').addClass('in');
                        // setTimeout(() => {
                        //     this.updateTinyMCEValues();
                        // }, 100);
                    }
                }
            }
        }
        if (this.completedActivityData && (this.completedActivityData['template'] == null || (this.completedActivityData['template']['name'] == null && this.completedActivityData['template']['customTags'] == null && this.completedActivityData['template']['message'] == null))) {
            // this.showCallNoteTemplateOption = false;
            this.showRecommendation = false;
            this.getUserList();
        }
        if (changes.customerId && this.customerId) {
            this.getCustomerCall();
        }
        // EDIT MODE
        // editCallData reaches this branch in two different shapes depending on the
        // caller: notification-pop-up's live-call widget builds a flat {note,
        // customCallField} object (contact number/call type are shown read-only from
        // the live call there, not part of this form), while the Communication tab
        // (filter-navbar) passes the raw activity record, which nests these fields
        // under `.communications` - the same shape the non-dialpad edit branch above
        // reads - and does expose contact number/call type as editable fields.
        if (this.userInfo && this.userInfo.dialpad === 1 && changes['editCallData'] && this.editCallData) {
            var communications_1 = this.editCallData.communications;
            this.callForm.patchValue(communications_1 ? {
                "contactTelephoneId": communications_1.contactNumberId,
                "note": communications_1.phoneCallNote,
                "callType": communications_1.calltype
            } : {
                note: this.editCallData.note || ''
            });
            setTimeout(function () {
                var cfs = communications_1 ? communications_1['customFields'] : _this.editCallData.customCallField;
                var editedCfs = {};
                Object.entries(cfs || {}).forEach(function (kvArray) {
                    if (kvArray[1]) {
                        editedCfs[kvArray[0]] = _this.customFieldsDirectResponse[kvArray[0]].find(function (f) { return f.id == kvArray[1]; });
                    }
                });
                _this.customFieldForm.patchValue(editedCfs);
                _this.refreshCustomFieldDdTogglerText();
                // increased 500 ms extra to get customFieldsDirectResponse
            }, 1500);
        }
        // ADD MODE (API returned no data)
        if (this.userInfo && this.userInfo.dialpad === 1 && changes['editCallData'] && this.editCallData === null) {
            this.callForm.reset({
                activityType: 'Call',
                callType: 'Outgoing Call'
            });
        }
    };
    CallLogModalComponent.prototype.getCustomerCall = function () {
        var _this = this;
        this.opportunityService.getCustomerContact(this.customerId).subscribe(function (data) {
            if (Object.values(data).length) {
                _this.customerCallDetails = data;
            }
            else {
                _this.isContactNotFound = true;
            }
        });
    };
    CallLogModalComponent.prototype.todayActivity = function () {
        var _this = this;
        this.opportunityService.getScheduledEmail(this.opportunityId, 'Call').subscribe(function (resp) {
            if (resp) {
                if (resp.length && resp[0].length) {
                    _this.callActivityShow = true;
                    _this.completed = true;
                    _this.todayActivityId = resp[0];
                }
                else {
                    _this.callActivityShow = false;
                    _this.completed = false;
                }
            }
        });
    };
    CallLogModalComponent.prototype.isFieldsValid = function (cf) {
        var isValidElement = cf.find(function (cfElement) { return cfElement.archived === 0; });
        return this.editId ? true : !!isValidElement;
    };
    CallLogModalComponent.prototype.buildForm = function () {
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    };
    CallLogModalComponent.prototype.closeModal = function (emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        this.editId = null;
        this.callForm.controls['activityType'].setValue('');
        this.callForm.controls['customerId'].setValue('');
        this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        if (this.screen == 'opportunity_call_log' || this.screen == 'opportunity') {
            this.scheduled = true;
        }
        else {
            this.scheduled = false;
        }
        this.activityIsScheduled = [];
        this.callActivityShow = false;
        this.showTemplateList = false;
        this.customTagForm = new FormGroup({});
        this.customFieldForm.reset();
        this.customTagsList = [];
        this.showRecommendation = false;
        this.completedActivityData = null;
        this.selectedCallNoteTemplate = null;
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if (emitEvent)
            this.onClose.emit(false);
    };
    CallLogModalComponent.prototype.isScheduledActivity = function (event) {
        this.scheduled = event.target.checked;
    };
    CallLogModalComponent.prototype.completeActivity = function (event) {
        this.completed = event.target.checked;
    };
    CallLogModalComponent.prototype.saveCall = function (type) {
        var _this = this;
        if (type == 'dialpad') {
            this.saveDisabled = true;
            this.callForm.get('customerId').setValue(this.customerId);
            var callData = this.callForm.value;
            if (this.customTagsList && this.customTagsList.length) {
                callData.customTags = this.customTagForm.value;
            }
            if (this.customFieldForm.valid && this.customFieldForm.value) {
                callData.callCustomField = this.customFieldForm.value;
            }
            // Communication tab only (this is the sole caller that ever sets `callinfo` -
            // see filter-navbar.component.ts): the dialpadActivityCall upsert needs
            // `communicationId` in the payload to be the activity's tablePkId, not its
            // communicationId, to correctly match/update this record.
            callData.communicationId = this.editCallData && this.editCallData.communications && this.editCallData.communications.tablePkId;
            this.integrationsService.postdialpadActivityCall(callData).subscribe(function (resp) {
                // Note: some backends omit `statusCode` on success - only treat it as a
                //      failure when the field is present and explicitly not 200.
                if (resp && (resp['statusCode'] === undefined || resp['statusCode'] == 200)) {
                    // postdialpadActivityCall already upserts the record (updates it when
                    // communicationId matches an existing call, adds it otherwise) - the
                    // `dialpad` flag tells the parent this save is already done, so it only
                    // needs to do its post-save housekeeping instead of performing its own
                    // (wrongly add-branched) save on top of this one. `callinfo` is only ever
                    // bound by filter-navbar, so this shape change can't reach any other consumer.
                    _this.onSave.emit({ dialpad: true, isScheduled: _this.scheduled, isUpdate: !!_this.editId });
                    _this.closeModal();
                }
                else if (resp['error'] != 200) {
                }
            });
        }
        else {
            this.saveDisabled = true;
            this.callForm.get('customerId').setValue(this.customerId);
            var callData = this.callForm.value;
            if (this.completed) {
                callData = this.callForm.value;
                var activityId = this.todayActivityId;
                /*if (this.activityIsScheduled.length != 0) {
                    for (var i = 0; i < this.activityIsScheduled.length; i++) {
                        activityId.push(this.activityIsScheduled[i]['activity_id'])
                    }
                } else {
                    if (this.scheduledData) {
                        if (this.scheduledData.hasOwnProperty('activity_id')) {
                            activityId.push(this.scheduledData.activity_id)
                        } else {
                            activityId.push(this.scheduledData.activityId)
                        }
                    }
                }*/
                callData.activityIds = activityId;
                if (this.todayActivityId) {
                    callData.activityIds = this.todayActivityId;
                }
            }
            if (this.customTagsList && this.customTagsList.length) {
                callData.customTags = this.customTagForm.value;
            }
            if (this.customFieldForm.valid && this.customFieldForm.value) {
                callData.callCustomField = this.customFieldForm.value;
            }
            // this.editId = event.editId;
            // callData.activityIds = this.activityEmail;
            var url = void 0;
            if (this.editId) {
                callData['opportunityId'] = this.opportunityId;
                this.screen == 'opportunity_notes' ? callData['communicationId'] = this.editCallData.communications.tablePkId : callData['communicationId'] = this.editCallData.communications.communicationId;
                url = "sales/edit_opportunity_call/" + this.editId;
            }
            else {
                url = "sales/opportunityActivityCall/" + this.opportunityId;
            }
            callData['selectedUsersList'] = this.selectedUsersList.length > 0 ? this.selectedUsersList : [];
            this.opportunityService.createOpportunityCall(callData, url).subscribe(function (data) {
                _this.sharedModalService.updateModalStatus('opportunity', 'call', false);
                // If this schedule, open the schedule activity modal
                _this.onSave.emit(_this.scheduled);
                _this.closeModal();
                _this.saveDisabled = false;
                // if (this.scheduledData) {
                //     if (this.scheduledData.hasOwnProperty('activityId')) {
                _this.opportunityService.refreshCompleteActivity('complete');
                //     }
                // }
            });
        }
    };
    CallLogModalComponent.prototype.getPhoneIcon = function (state) {
        var icons = {
            'ringing': '/images/ringing.svg',
            'connected': '/images/Phone.svg',
            'hangup': '/images/Stacked.svg',
            'recap_summary': '/images/Stacked.svg',
            'hold': '/images/Pause.svg',
            'missed': '/images/MissedCall.svg',
            'conflictedClient': '/images/ConflictedCall.svg'
        };
        return icons[state] || '/images/Phone.svg';
    };
    // Accepts both the raw Dialpad value ('outbound', from live PubNub) and 'Outbound call' (from the API).
    CallLogModalComponent.prototype.isOutboundCall = function (call) {
        return !!call && typeof call.direction === 'string' && call.direction.toLowerCase().indexOf('outbound') === 0;
    };
    CallLogModalComponent.prototype.getDisplayIcon = function (call) {
        if (call && call.matchfound === 1 && call.state !== 'hold' && call.state !== 'missed') {
            return '/images/ConflictedCall.svg';
        }
        // Superseded: the template now shows the call-activity outgoing icon (fa-phone-flip)
        // for a connected outbound call instead of an image.
        // if (call && call.state === 'connected' && call.direction === 'Outbound call') {
        //     return '/images/OutboundCall.svg';
        // }
        return this.getPhoneIcon(call ? call.state : undefined);
    };
    // Note: a plain <a href> only navigates reliably when the current route is already
    //      AngularJS/html5Mode-owned - on any other route (e.g. an Angular-7-owned route)
    //      the click isn't picked up. HybridFactory.navigate() is the app's sanctioned way
    //      to cross frameworks regardless of the current route (see notification-pop-up
    //      .component.ts's goToAddNewCustomer, which uses the same call for this same link).
    CallLogModalComponent.prototype.goToAddNewCustomer = function (event) {
        event.preventDefault();
        HybridFactory.navigate('/customers/new_customer/1/new', {
            type: 'dialpad',
            callId: this.userInfo ? this.userInfo.callId : null,
            number: this.userInfo ? this.userInfo.contactnumber : null
        });
    };
    CallLogModalComponent.prototype.closeModalConfirmation = function () {
        var _this = this;
        if (this.isNotificationPopup) {
            // Notification popup close (drag-line / Escape) closes straight away -
            // no discard-confirmation prompt for this entry point.
            this.closeModal();
            return;
        }
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
            .then(function () {
            _this.closeModal();
        }).catch(function () { });
    };
    CallLogModalComponent.prototype.setTemplateDetails = function (selectedTemplate) {
        var _this = this;
        selectedTemplate.message = selectedTemplate.message ? selectedTemplate.message : selectedTemplate.value;
        selectedTemplate.message = selectedTemplate.template ? selectedTemplate.template.message : selectedTemplate.message;
        this.callForm.controls['note'].setValue(selectedTemplate['message']);
        if (selectedTemplate.customTags || (selectedTemplate.template && selectedTemplate.template.customTags)) {
            this.customTagForm = new FormGroup({});
            var customTagsList = JSON.parse(selectedTemplate.customTags || selectedTemplate.template.customTags);
            customTagsList = customTagsList.map(function (ct) {
                ct.name = ct.name.replaceAll('{', '').replaceAll('}', '');
                _this.customTagForm.addControl(ct.name, new FormControl('', Validators.required));
                return ct;
            });
            this.customTagsList = customTagsList;
        }
        else {
            this.customTagsList = [];
            this.customTagForm = new FormGroup({});
        }
        // this.updateTinyMCEValues();
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    CallLogModalComponent.prototype.showTemplateOptions = function () {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    };
    CallLogModalComponent.prototype.cancelTemplate = function () {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    CallLogModalComponent.prototype.replaceCustomTags = function (tagName) {
        var replacingValue = this.customTagForm.value[tagName.replaceAll('{', '').replaceAll('}', '')];
        if (replacingValue) {
            var iframe = $('quill-editor');
            var cts = $("span[data-value='" + tagName + "']", iframe.contents());
            cts.each(function (index, ct) {
                $(ct).find('span').html(replacingValue);
                $(ct).removeClass('mention custom_tag');
            });
            var updatedNote = iframe.contents().find('.ql-editor')[0].innerHTML;
            this.callForm.controls.note.setValue(updatedNote);
        }
    };
    CallLogModalComponent.prototype.ngOnDestroy = function () {
        this.opportunityService.refreshCompleteActivity(null);
        this.customFields = [];
    };
    CallLogModalComponent.prototype.onContentChange = function (event) {
        if (event.text === '\n') {
            this.saveDisabled = true;
        }
        else {
            this.saveDisabled = false;
        }
        this.onChange();
        var contentEl = $(event.html).find('[data-denotation-char=""]');
        this.selectedUsersList = [];
        if (contentEl.length) {
            var _loop_1 = function (i) {
                var index = this_1.selectedUsersList.findIndex(function (data) { return data == contentEl[i].dataset['id']; });
                if (index < 0) {
                    this_1.selectedUsersList.push(contentEl[i].dataset['id']);
                }
            };
            var this_1 = this;
            for (var i = 0; i < contentEl.length; i++) {
                _loop_1(i);
            }
        }
    };
    CallLogModalComponent.prototype.getUserList = function () {
        if (this.usersList) {
            for (var index = 0; index < this.usersList.length; index++) {
                this.usersList[index]['value'] = this.usersList[index]['username'];
                this.users.push(this.usersList[index]);
            }
        }
    };
    CallLogModalComponent.prototype.prepareCallSavePayload = function () {
        var formValue = this.callForm ? this.callForm.value : {};
        return tslib_1.__assign({}, formValue, { customerId: this.userInfo && this.userInfo.customerId
                ? this.userInfo.customerId
                : formValue.customerId, callId: this.userInfo ? this.userInfo.callId : null, contactnumber: this.userInfo ? this.userInfo.contactnumber : null, direction: this.userInfo ? this.userInfo.direction : null, name: this.userInfo ? this.userInfo.name : null, address: this.userInfo ? this.userInfo.address : null, dialpad: this.userInfo ? this.userInfo.dialpad : 0, state: this.userInfo ? this.userInfo.state : 0 });
    };
    // Dial Pad only - replaces the native <select> for a customField with the searchable
    // app-cs-drop-down (Angular-native; its search box/menu stay inside the modal's own DOM,
    // unlike jQuery Select2 which appends to <body> and gets its focus stolen back by this
    // modal's legacy Bootstrap enforceFocus - see call-log-modal.component.html).
    CallLogModalComponent.prototype.buildCustomFieldDdConfig = function (cf) {
        var currentValue = this.customFieldForm && this.customFieldForm.value ? this.customFieldForm.value[cf.key] : null;
        return {
            id: "custom_field_" + cf.key,
            // custom-fields-section sits right above the modal footer, with little room below
            // and .modal-body clipping overflow - opening upward keeps the menu on screen.
            isDropUp: true,
            ddTogglerConfig: {
                templateType: 'BTN_TRANSPARENT',
                templateData: {
                    text: (currentValue && currentValue.description) || '-- Please select --'
                }
            },
            ddMenuConfig: {
                isSearchBar: true,
                templateType: 'BASIC',
                items: (cf.value || [])
                    .filter(function (value) { return value.archived != 1; })
                    .map(function (value) { return ({
                    id: value.id,
                    templateData: { text: value.description },
                    itemData: value
                }); })
            }
        };
    };
    CallLogModalComponent.prototype.onCustomFieldDdSelect = function (cf, item) {
        this.customFieldForm.controls[cf.key].setValue(item.itemData);
    };
    // Dial Pad only - keeps each dropdown's toggler text in sync after an edit-mode
    // customFieldForm.patchValue() sets a value the dropdown wasn't built with.
    CallLogModalComponent.prototype.refreshCustomFieldDdTogglerText = function () {
        var _this = this;
        this.customFields.forEach(function (cf) {
            if (!cf.ddConfig) {
                return;
            }
            var currentValue = _this.customFieldForm.value[cf.key];
            cf.ddConfig.ddTogglerConfig.templateData.text = (currentValue && currentValue.description) || '-- Please select --';
        });
    };
    CallLogModalComponent.prototype.saveCallCommunication = function () {
        var _this = this;
        var callData = this.prepareCallSavePayload();
        if (this.customFieldForm.valid && this.customFieldForm.value) {
            callData.callCustomField = this.customFieldForm.value;
        }
        this.integrationsService.postdialpadActivityCall(callData).subscribe(function (resp) {
            if (resp['statusCode'] == 200) {
                // Missed calls follow the same "call complete" scenario as hangup calls -
                // it moves the bar into recap_summary and then auto-removes it.
                if (callData.state == 'hangup' || callData.state == 'missed') {
                    _this.sendValue.emit({
                        callId: callData.callId,
                        callstate: 'call complete',
                    });
                }
                _this.closeModal();
            }
            else if (resp['error'] != 200) {
            }
        });
    };
    return CallLogModalComponent;
}());
export { CallLogModalComponent };
